import { z } from 'zod'

export const Purchase = z.object({
  id: z.string().uuid(),
  date: z
    .number()
    .int()
    .min(-9_223_372_036_854_775_808)
    // eslint-disable-next-line no-loss-of-precision
    .max(9_223_372_036_854_775_807),
  due_date: z
    .number()
    .int()
    .min(-9_223_372_036_854_775_808)
    // eslint-disable-next-line no-loss-of-precision
    .max(9_223_372_036_854_775_807),
  amount: z.number(),
  currency: z.string(),
  status: z.enum(['done', 'waiting_for_payment', 'refunded', 'fulfillment'])
})

export type Purchase = z.infer<typeof Purchase>
